var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.04 7.293a1 1 0 0 1 0 1.414L7.747 15h18.92a1 1 0 0 1 0 2H7.747l6.293 6.293a1 1 0 1 1-1.413 1.414l-8-8a1 1 0 0 1 0-1.414l8-8a1 1 0 0 1 1.413 0",
    clipRule: "evenodd"
  })));
};
export default SvgBackArrow;